import Modal from "components/modal/Modal";
import ctcGif from "assets/images/ctc-popup.gif";
import "./ctc-popup.scss";
import { CTC_POPUP_DESCRIPTION, CTC_POPUP_HEADER } from "utilities/Constant";

export default function CtcPopup() {
  return (
    <div className="ctc-popup-container">
      <Modal
        customBody={
          <div className="ctc-popup">
            <img className="ctc-popup__gif" src={ctcGif} alt="CTC Popup" />
            <h5 className="ctc-popup__title">{CTC_POPUP_HEADER}</h5>
            <p className="ctc-popup__description">{CTC_POPUP_DESCRIPTION}</p>
          </div>
        }
      />
    </div>
  );
}
